import { Brand } from "~/types/entities";

const getEmailPlaceHolder = (brand: string): string => {
  return brand === Brand.sportbenefit 
    ? "qwerty@sportbenefit.eu"
    : "qwerty@allsports.by";
};

export default getEmailPlaceHolder;